import AppShowcase from "./components/AppShowcase";
import Contact from "./components/Contact";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Navbar from "./components/Navbar";
import StatsBar from "./components/Statusbar";
import Testimonials from "./components/testimonials";

export default function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <StatsBar />
      <HowItWorks />
      <Features/>
      <AppShowcase/>
      <Testimonials/>
      <Contact />
      <Footer />
    </div>
  );
}
